import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import Authenticated from 'Components/Layouts/Authenticated';
import CmsElement from "Components/Utilities/CmsElement";
import {Loading} from "Components/Partials";
import {RenderWYSIWYG} from "Components/Form";

import {getRecordValue} from "Services/CmsHelpers";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { Container } from "Components/Utilities";
import { Link } from "Components/Utilities";

export default class FAQ extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'faq';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var allowUpdate
     * @type {boolean}
     */
    allowUpdate = false;

    /**
     * @var state
     */
    state = {
        working: true,
        openSections: {}
    };

    toggleSection = (index) => {
        this.setState(prevState => ({
            openSections: {
                ...prevState.openSections,
                [index]: !prevState.openSections[index]
            }
        }));
    };
    render () {
        const { working, records } = this.state;
        const content = {};
        let faq = [];

        if (records) {
            records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'content')
                .forEach(item => {
                    content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
                });

            faq = records.data
                .filter(item => getRecordValue(item, 'type').toLowerCase() === 'question')
                .map(item => ({
                    question: getRecordValue(item, 'title'),
                    answer: getRecordValue(item, 'content'),
                }));
        }

        return (
            <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                {working && <Loading />}

                {!working && (
                    <>
                        {/*<div className={ "py-8 lg:py-12 space-y-6 text-center mx-auto text-app-blue" }>*/}
                        {/*    <div className={ "text-3xl text-app-blue font-bold" }>*/}
                        {/*        FAQ*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className="bg-app-darker-blue py-5 lg:py-10 text-app-secondary-text">
                            <Container>
                                <div className="flex gap-6 lg:gap-20">
                                    <div className="w-full lg:w-1/2 rounded-xl">
                                        <div className="aspect-w-1 aspect-h-1">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.347434497204!2d-0.1291806842294922!3d51.49947957963392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604c5d5b5b5b5%3A0x5b5b5b5b5b5b5b5b!2sQEII%20Centre!5e0!3m2!1sen!2sus!4v1631542618471!5m2!1sen!2sus"
                                            />
                                        </div>
                                    </div>
                                    <div className="w-full lg:w-1/2 flex flex-col justify-start">
                                        <p className="text-3xl font-bold mb-4">Location</p>
                                        <p className="mb-2 text-2xl">This year’s event will be held at:</p>
                                        <p className="text-lg font-bold">QEII Centre</p>
                                        <p className="text-lg font-bold">Broad Sanctuary</p>
                                        <p className="text-lg font-bold">Westminster</p>
                                        <p className="text-lg font-bold">London</p>
                                        <p className="text-lg font-bold">SW1P 3EE</p>
                                    </div>
                                </div>
                            </Container>
                        </div>

                        <div className="py-5 lg:py-10 space-y-6 text-center mx-auto text-app-blue">
                            <Container>
                                <p className="text-xl font-bold mb-6">
                                    Healthcare in Focus – Bupa Symposium 2025
                                </p>
                                <p className="text-xl my-6">
                                    Health is more than just one thing.
                                </p>
                                <p className="text-xl my-6">
                                    It’s the microscopic patterns in our DNA.
                                    The choices we make - how we eat, rest and connect.
                                    And the world around us; the air we breathe, the spaces we inhabit, and the systems that shape our well-being.
                                </p>
                                <p className="text-xl my-6">
                                    No two people experience health in the same way,
                                    so healthcare should be just as individual.
                                </p>
                                <p className="text-xl my-6">
                                    At the Bupa Symposium we’re bringing together the experts, insights and ideas that put healthcare into focus - from the smallest details, to the bigger picture.
                                </p>
                                <p className="text-xl my-6">
                                    Because the future is where healthcare is built around who we are, how we live and where we live.
                                </p>
                            </Container>
                        </div>

                        {/*<div className="max-w-4xl mx-auto py-10 px-5 md:px-10">*/}
                            {/*<div className="flex justify-center pb-4">*/ }
                            {/*    <img*/ }
                            {/*        src={ asset ( 'images/mini-logo.png' ) }*/ }
                            {/*        alt="Logo"*/ }
                            {/*        className="block w-20 align-self-center"*/ }
                            {/*    />*/ }
                            {/*</div>*/ }

                            {/*<div className="text-center">*/}
                            {/*    <RenderWYSIWYG*/}
                            {/*        className="text-black"*/}
                            {/*        content={ content[ 'Welcome Text' ] ?? '' }*/}
                            {/*    />*/}
                            {/*</div>*/}

                            {/*<p className={"text-app-blue text-center text-xl"}>*/}
                            {/*    Please find our frequently asked questions below.*/}
                            {/*    If your query isn't answered please contact us at*/}
                            {/*    {" "}*/}
                            {/*    <a href="mailto:healthcaresymposium@bupa.com" className="text-app-blue text-xl cursor-pointer" >*/}
                            {/*        healthcaresymposium@bupa.com*/}
                            {/*    </a>.*/}

                            {/*</p>*/}
                        {/*</div>*/}

                        {/*{ this.renderFAQSection ( faq ) }*/}
                    </>
                ) }
            </Authenticated>
        );
    }

    renderFAQSection(records) {
        return (
            <Container>
            <section className="grid grid-cols-1 gap-y-3 divide-y border-t-1 border-gray-200">
                {records.map((item, key) => (
                    <details
                        className="group py-1 text-md p-5 text-left"
                        key={`question-${key}`}
                    >
                        <summary
                            className="flex cursor-pointer uppercase flex-row item-left justify-between py-1 marker:[font-size:0px] p-5 text-app-blue"
                            onClick={() => this.toggleSection(key)}
                        >
                            {item.question}
                            <FontAwesomeIcon
                                icon={this.state.openSections[key] ? faChevronUp : faChevronDown}
                                className="mr-2 text-app-blue"
                            />
                        </summary>

                        <p className="font-mediuml text-left text-sm p-5 text-app-blue">
                            <RenderWYSIWYG content={item.answer} className="text-app-blue" />
                        </p>

                        {item.question === 'What is the venue location?' && (
                            <div className={ "p-5 w-full lg:w-1/2 flex text-white flex-col justify-center h-[40em]" }>
                                <div className="aspect-w-1 aspect-h-1">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.821399711187!2d-0.09050768422949219!3d51.52061497963628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b2f9b7b6b1d%3A0x4107a6476440dd0!2s52%20Chiswell%20St%2C%20London%20EC1Y%204SA%2C%20UK!5e0!3m2!1sen!2sus!4v1631542618471!5m2!1sen!2sus"
                                    />
                                </div>
                            </div>
                        )}
                    </details>
                ))}
            </section>
        </Container>
        );
    }
}
